import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import config from "../../config";
import { UpdateSystemParameter } from "./types";

const api = new APICore();

function fetchSystemParametersApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters`;
  return api.get(`${baseUrl}`, params);
}

function fetchSystemParameterByIdApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params}`;
  return api.get(`${baseUrl}`, {});
}

function updateSystemParameterApi(params: any) {
  let backendApiUrl = "";

  let apiData: any = {
    npaDpd: params.npaDpd !== undefined ? Number(params.npaDpd) : 0
  };

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params.externalId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params.externalId}?draft=${params.draft}`;
  }

  return api.update(`${backendApiUrl}`, apiData);
}

function fetchSystemParameterVersionApi(params: any) {
  console.log("params", params);
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params.id}/versions`;
  return api.get(`${baseUrl}`, {});
}

function fetchSystemParameterLatestVersionApi(params: any) {
  const flag = {
    modifyLatest: params?.status === "New" ? false : true
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params?.externalId}/latestVersion`;
  return api.get(`${baseUrl}`, flag);
}

function fetchSystemParameterVersionDetailsApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params?.externalID}/versions/${params?.internalID}`;
  return api.get(`${baseUrl}`, {});
}

function approveSystemParameterApi(params: any) {
  const remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params.externalId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function rejectSystemParameterApi(params: any) {
  const remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/financier-system-parameters/${params.externalId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

export {
  fetchSystemParametersApi,
  fetchSystemParameterByIdApi,
  updateSystemParameterApi,
  fetchSystemParameterVersionApi,
  fetchSystemParameterLatestVersionApi,
  fetchSystemParameterVersionDetailsApi,
  approveSystemParameterApi,
  rejectSystemParameterApi
};
